import { connect } from 'react-redux';
import { getZdvlByTask, getZdvlByTaskFail } from '../../store/actions/savedProducts';
import { setInitialStateReport } from '../../store/actions/report';
import {
  addTaskSemi,
  addTaskZdvlLine,
  deleteTaskSemi,
  deleteTaskZdvlLine,
  getSemiListByTask,
  getTaskList,
  setOpenCloseTask,
  setInitialStateTask
} from '../../store/actions/task';
import TaskTab from './TaskTab';

const mapStateToProps = ({
  taskReducer,
  savedProductsReducer,
  tabsReducer,
  userReducer
}) => ({
  taskReducer,
  savedProductsReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getSemiListByTask,
  getTaskList,
  addTaskSemi,
  addTaskZdvlLine,
  deleteTaskSemi,
  deleteTaskZdvlLine,
  getZdvlByTask,
  getZdvlByTaskFail,
  setInitialStateReport,
  setOpenCloseTask,
  setInitialStateTask
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskTab);
